import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { IconCheck, IconRefresh, IconX } from '@tabler/icons-react';
import React from 'react';
import { useDatabaseStatus } from 'src/api/queries/admin/useHealthcheck';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { getErrorMessage } from 'src/utils';

export const DatabaseStatusPanel: React.FC = () => {
  const { data, error, isFetching, refetch } = useDatabaseStatus();

  // A failed probe is itself the answer, so an unreachable endpoint renders
  // as "both databases down" rather than as an error state.
  const databaseStatus = error
    ? {
        firetrolOnly: false,
        greatPlainsOnline: false,
        firetrolMessage: getErrorMessage(error),
        greatPlainsMessage: getErrorMessage(error),
      }
    : data;

  return (
    <Paper withBorder p="md">
      <Stack gap="md">
        <Title order={4}>Database Status</Title>

        <Text>Check the connection status to each database.</Text>

        {databaseStatus && (
          <Stack gap="sm">
            <Group>
              {databaseStatus.firetrolOnly ? (
                <IconCheck size={20} color="green" />
              ) : (
                <IconX size={20} color="red" />
              )}
              <Text size="md">Firetrol Database</Text>
            </Group>
            {databaseStatus.firetrolMessage && (
              <Text size="sm" c="red">
                {databaseStatus.firetrolMessage}
              </Text>
            )}

            <Group>
              {databaseStatus.greatPlainsOnline ? (
                <IconCheck size={20} color="green" />
              ) : (
                <IconX size={20} color="red" />
              )}
              <Text size="md">Great Plains Database</Text>
            </Group>
            {databaseStatus.greatPlainsMessage && (
              <Text size="sm" c="red">
                {databaseStatus.greatPlainsMessage}
              </Text>
            )}
          </Stack>
        )}

        {!databaseStatus && !isFetching && (
          <Text size="sm" c="dimmed">
            Click refresh to check database status
          </Text>
        )}
        <BasicButton
          onClick={() => refetch()}
          loading={isFetching}
          leftSection={<IconRefresh size={16} />}
          size="sm"
          w="fit-content"
        >
          Refresh
        </BasicButton>
      </Stack>
    </Paper>
  );
};
